import {Component} from "../enum/Component";
import {ConditionalState} from "../enum/ConditionalState";
import moment from "moment/moment";
import {ValidationUtil} from "./ValidationUtil";

export class SchemaUtils {

    public static getComponentSchema = (path: string, rootSchema: any) => {
        if (!path || !rootSchema?.properties) {
            return null;
        }

    const componentPath = path.split('.').slice(0, -1);
    let node: any = rootSchema.properties;

    for (let i = 0; i < componentPath.length; i++) {
        const part = componentPath[i];
        if (!node?.[part]) return null;
        if (i === componentPath.length - 1) return node[part];
        node = node[part].properties;
    }
        return null;
    };

    public static isRequired(path: string, rootSchema: any) {
        var arrStr = path.split(/[..]/);
        let required = rootSchema.properties[arrStr[0]].properties[arrStr[1]].required;
        if(required !== undefined){
            return required.includes(arrStr[2]);
        }
        return false;
    }

    public static isComponentVisible(uiSchema: any, data: any, postSubmission = false){
        return this.isEitherState("show", "hide", uiSchema.rule, data, postSubmission);
    }

    public static isComponentEnabled(uiSchema: any, data: any){
        return this.isEitherState("enable", "disable", uiSchema.rule, data);
    }

    public static getRelevantUiSchema(uiSchema: any, appData: any, page: string, component: string) {
        const componentType = Object.keys(appData[page][component])[0];
        let scope = "#/properties/" + page + "/properties/" + component + "/properties/" + componentType;
        let i = 0, len = uiSchema.elements.length;
        loop2:
            while (i < len) {
                const pageElem = uiSchema.elements[i];
                let j = 0, lenPageElem = pageElem.elements.length;
                while (j < lenPageElem) {
                    const componentElem = pageElem.elements[j];
                    if (componentElem.scope === scope) {
                        uiSchema = componentElem;
                        break loop2;
                    }
                    j++;
                }
                i++;
            }
        return uiSchema;
    }

    public static resetDataValue(scope: string, jsonForms: any, value: any) {
        const properties = scope.split("/properties/");
        const [page, component, type] = properties.slice(1, 4);
        jsonForms.core!.data[page] ??= {};
        jsonForms.core!.data[page][component] ??= {};
        jsonForms.core!.data[page][component][type] =
            ValidationUtil.isEmptyValue(value) ? (type === Component.Checkbox ? [] : "") : value;
    }

    public static getDefaultValue(scope: string, jsonForms: any): string|number{
        const properties = scope.split("/properties/");
        const page = properties[1];
        const component = properties[2];
        const type = properties[3];
        let defaultValue: any = jsonForms.core!.schema.properties[page].properties[component].properties[type].default;
        if(type === Component.Date){
            defaultValue = !ValidationUtil.isEmptyValue(defaultValue) ? defaultValue : "";
        } else if(type === Component.Time){
            defaultValue = !ValidationUtil.isEmptyValue(defaultValue) ? defaultValue : "";
        }
        return defaultValue ?? "";
    }

    public static getPaymentPrice(rules: any, data: any, defaultPrice: number){
        let i = 0, len = rules.length;
        while (i < len) {
            const rule = rules[i];
            if(rule !== null && rule !== undefined){
                const anyOf = rule.condition.schema.anyOf;
                const allOf = rule.condition.schema.allOf;
                if(anyOf !== undefined){
                    let j = 0, lenAny = anyOf.length;
                    while (j < lenAny) {
                        const anyOfRegexTestResult = SchemaUtils.isValueValidAccordingToRule(anyOf[j], data);
                        if(anyOfRegexTestResult)
                        {
                            return rule.price.toFixed(2);
                        }
                        j++;
                    }
                }
                else if(allOf !== undefined){
                    let j = 0, lenAll = allOf.length, allRegexTestResults = true;
                    while (j < lenAll) {
                        const allOfRegexTestResult = SchemaUtils.isValueValidAccordingToRule(allOf[j], data);
                        allRegexTestResults = allRegexTestResults && allOfRegexTestResult;
                        j++;
                    }
                    if(allRegexTestResults){
                        return rule.price.toFixed(2);
                    }
                }
            }
            i++;
        }
        return defaultPrice.toFixed(2);
    }

    private static isEitherState(onState: string, offState: string, rule: any, data: any, postSubmission = false){
        if((rule !== null && rule !== undefined) && (rule.effect === offState || rule.effect === onState)){
            const anyOf = rule.condition.schema.anyOf;
            const allOf = rule.condition.schema.allOf;
            if(anyOf !== undefined){
                let i = 0, len = anyOf.length;
                while (i < len) {
                    const anyOfRegexTestResult = SchemaUtils.isValueValidAccordingToRule(anyOf[i], data);
                    if(anyOfRegexTestResult)
                    {
                        return rule.effect === offState ? !anyOfRegexTestResult : anyOfRegexTestResult;
                    }
                    i++;
                }
                return rule.effect === offState;
            }
            else if(allOf !== undefined){
                let i = 0, len = allOf.length;
                let allRegexTestResults = true;
                while (i < len) {
                    const allOfRegexTestResult = SchemaUtils.isValueValidAccordingToRule(allOf[i], data);
                    allRegexTestResults = allRegexTestResults && allOfRegexTestResult;
                    i++;
                }
                if(allRegexTestResults){
                    return rule.effect === offState ? !allRegexTestResults : allRegexTestResults;
                }
                return rule.effect === offState;
            }
            return postSubmission;
        }
        return true;
    }

    private static isValueValidAccordingToRule(aOf: any, data: any): boolean {
        const propertyScope = Object.keys(aOf.properties)[0];
        const properties = propertyScope.split("/properties/");
        let propertyValue = data[properties[1]]?.[properties[2]]?.[properties[3]];
        const propertyType = properties[3];
        let property = aOf.properties[propertyScope];
        const description = property.description;
        let valid, regex = new RegExp(property.pattern);
        switch (description){
            case ConditionalState.IsGreaterThan:
                if(propertyType === Component.FileUpload || propertyType === Component.Columns){
                    valid = Array.isArray(propertyValue) &&
                        propertyValue.length > +property.exclusiveMinimum;
                }else {
                    valid = ValidationUtil.isEmptyValue(propertyValue) ? false : +propertyValue > +property.exclusiveMinimum;
                }
                break;
            case ConditionalState.IsLessThan:
                if(propertyType === Component.FileUpload || propertyType === Component.Columns){
                    valid = Array.isArray(propertyValue) &&
                        propertyValue.length < +property.exclusiveMaximum;
                }else{
                    valid = ValidationUtil.isEmptyValue(propertyValue) ? false : +propertyValue < +property.exclusiveMaximum;
                }
                break;
            case ConditionalState.DayOfWeekIs:
            case ConditionalState.DayOfMonthIs:
            case ConditionalState.MonthIs:
            case ConditionalState.YearIs:
                if(!ValidationUtil.isEmptyValue(propertyValue)){
                    const check = moment(propertyValue, 'YYYY-MM-DD').locale("en-gb");
                    const name = check.format(description === ConditionalState.DayOfWeekIs ? "dddd" :
                        (description === ConditionalState.DayOfMonthIs ? "D" :
                            (description === ConditionalState.MonthIs ? "MMMM" : "YYYY"))).toLowerCase();
                    valid = regex.test(name);
                }else if(propertyValue === ""){
                    valid = regex.test(propertyValue);
                }else{
                    valid = false;
                }
                break;
            case ConditionalState.IsAfter:
            case ConditionalState.IsBefore:
            case ConditionalState.IsSelectedCountEqual:
                if(!ValidationUtil.isEmptyValue(propertyValue)) {
                    if(propertyType === Component.Date){
                        const value = moment(propertyValue, 'YYYY-MM-DD').locale("en-gb");
                        const rule = moment(property.const, 'YYYY-MM-DD').locale("en-gb");
                        valid = (description === ConditionalState.IsAfter) ? value.isAfter(rule) : value.isBefore(rule);
                    }else if(propertyType === Component.Time){
                        const value = moment(propertyValue, 'hh:mm').locale("en-gb");
                        const rule = moment(property.const, 'hh:mm').locale("en-gb");
                        valid = (description === ConditionalState.IsAfter) ? value.isAfter(rule) : value.isBefore(rule);
                    }else{
                        valid = Array.isArray(propertyValue) && propertyValue.length === +property.const;
                    }
                }else if(propertyValue === ""){
                    valid = regex.test(propertyValue);
                }else {
                    valid = false;
                }
                break;
            case ConditionalState.Is:
            case ConditionalState.IsNot:
                try {
                    switch (propertyType){
                        case Component.Checkbox: {
                            if (!Array.isArray(propertyValue)) {
                                valid = false;
                                break;
                            }

                            if (propertyValue.length === 0) {
                                valid = regex.test("");
                                break;
                            }

                            if (description === ConditionalState.Is) {
                                // Return true if ANY checkbox passes validation
                                valid = propertyValue.some(value => regex.test(value));
                            } else {
                                // Return true if ALL checkboxes pass validation
                                valid = propertyValue.every(value => regex.test(value));
                            }
                            break;
                        }
                        case Component.Select:
                        case Component.Radio: {
                            valid = regex.test(propertyValue);
                            break;
                        }
                        default:
                            valid = false;
                            break;
                    }
                } catch (e) {
                    valid = false;
                }
                break;
            default:
                if(propertyType === Component.FileUpload || propertyType === Component.Columns) {
                    valid = regex.test(ValidationUtil.isEmptyValue(propertyValue) ? "" : propertyValue.length);
                } else {
                    valid = regex.test(ValidationUtil.isEmptyValue(propertyValue) ? "" : propertyValue);
                }
                break;
        }
        return valid;
    }

    private static validateAllProperties(objects: any[], regex: RegExp): boolean {
        return objects.some(obj => {
            return this.validateObject(obj, regex);
        });
    }

    private static validateObject(obj: any, regex: RegExp): boolean {
        return Object.values(obj).some(value => {
            if (typeof value === 'object' && value !== null) {
                // Recursively validate nested objects
                return this.validateObject(value, regex);
            } else {
                // Validate primitive values using pattern
                const valueToTest: any = ValidationUtil.isEmptyValue(value) ? "" : value;
                return regex.test(valueToTest);
            }
        });
    }

}
